import C from 'actionTypes'

export const setWindowMode = d => ({
  type: C.SET_WINDOW_MODE,
  dimensions: d
})

export const openNav = () => ({
  type: C.OPEN_NAV
})

export const closeNav = () => ({
  type: C.CLOSE_NAV
})

export const setIsLoading = value => ({
  type: C.SET_IS_LOADING,
  value
})

export const setError = error => ({
  type: C.SET_ERROR,
  error
})

export const clearError = () => ({
  type: C.CLEAR_ERROR,
})

export default {
  setWindowMode,
  openNav,
  closeNav,
  setIsLoading,
  setError,
  clearError,
}



// WEBPACK FOOTER //
// ./src/actions/onboarding.js